/*!

=========================================================
* Material Dashboard React - v1.8.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/material-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
// @material-ui/icons
import Person from "@material-ui/icons/Person";
import LibraryBooks from "@material-ui/icons/LibraryBooks";
import Home from "@material-ui/icons/Home";
import School from "@material-ui/icons/School";
import Work from "@material-ui/icons/Work";
import WbIncandescentIcon from '@material-ui/icons/WbIncandescent';
import LocalHospital from "@material-ui/icons/LocalHospital";
import Healing from "@material-ui/icons/Healing";
import Restaurant from "@material-ui/icons/Restaurant";
import Group from "@material-ui/icons/Group";
import Business from "@material-ui/icons/Business";

// core components/views for Admin layout
import DashboardPage from "views/Dashboard-enpas/Dashboard-enpas";
// core components/views for RTL layout

const dashboardRoutes = [
  {
    path: "/datosgenerales",
    name: "Datos generales",
    rtlName: "ملف تعريفي للمستخدم",
    icon: LibraryBooks,
    iframeUrl: 'http://esriven.maps.arcgis.com/apps/opsdashboard/index.html#/7ea56701f520409ab0d646a37650a11e',
    component: DashboardPage,
    layout: "/admin"
  },
  {
    path: "/vivienda",
    name: "Vivienda",
    rtlName: "ملف تعريفي للمستخدم",
    icon: Home,
    iframeUrl: 'http://esriven.maps.arcgis.com/apps/opsdashboard/index.html#/c30b17d10eb440308e54b456086e3fdd',
    component: DashboardPage,
    layout: "/admin"
  },
  {
    path: "/estudios",
    name: "Estudios",
    rtlName: "ملف تعريفي للمستخدم",
    icon: School,
    iframeUrl: 'http://esriven.maps.arcgis.com/apps/opsdashboard/index.html#/f8c9cae659714942a351a2118c04633b',
    component: DashboardPage,
    layout: "/admin"
  },
  {
    path: "/trabajo",
    name: "Trabajo",
    rtlName: "ملف تعريفي للمستخدم",
    icon: Work,
    iframeUrl: 'http://esriven.maps.arcgis.com/apps/opsdashboard/index.html#/1b9fa8277b0946719e7cdd81f04d72c1',
    component: DashboardPage,
    layout: "/admin"
  },
  {
    path: "/serviciospublicosysanitarios",
    name: "Servicios públicos y sanitarios",
    rtlName: "ملف تعريفي للمستخدم",
    icon: WbIncandescentIcon,
    iframeUrl: 'http://esriven.maps.arcgis.com/apps/opsdashboard/index.html#/4d5403da55c64571a8a29bc3605eee5b',
    component: DashboardPage,
    layout: "/admin"
  },
  {
    path: "/serviciosdesalud",
    name: "Servicios de salud",
    rtlName: "ملف تعريفي للمستخدم",
    icon: LocalHospital,
    iframeUrl: 'http://esriven.maps.arcgis.com/apps/opsdashboard/index.html#/93acf6a2f8e1408782eb16a9cfefa7ec',
    component: DashboardPage,
    layout: "/admin"
  },
  {
    path: "/enfermedades",
    name: "Enfermedades",
    rtlName: "ملف تعريفي للمستخدم",
    icon: Healing,
    iframeUrl: 'http://esriven.maps.arcgis.com/apps/opsdashboard/index.html#/e02d36b0fe6a4d17a63fe89989db6606',
    component: DashboardPage,
    layout: "/admin"
  },
  {
    path: "/nutricion",
    name: "Nutrición",
    rtlName: "ملف تعريفي للمستخدم",
    icon: Restaurant,
    iframeUrl: 'http://esriven.maps.arcgis.com/apps/opsdashboard/index.html#/d86f6f99e9be43b4bc4e118800b684e8',
    component: DashboardPage,
    layout: "/admin"
  },
  {
    path: "/habitospersonales",
    name: "Hábitos personales",
    rtlName: "ملف تعريفي للمستخدم",
    icon: Person,
    iframeUrl: 'http://esriven.maps.arcgis.com/apps/opsdashboard/index.html#/24f35b950e014c5e9dbeb844fb47f17e',
    component: DashboardPage,
    layout: "/admin"
  },
  {
    path: "/nucleofamiliar",
    name: "Núcleo familiar",
    rtlName: "ملف تعريفي للمستخدم",
    icon: Group,
    iframeUrl: 'http://esriven.maps.arcgis.com/apps/opsdashboard/index.html#/8f8048cd4eb4443eac0e01e411000616',
    component: DashboardPage,
    layout: "/admin"
  },
  {
    path: "/relacionesconlacomunidad",
    name: "Relaciones con la comunidad",
    rtlName: "ملف تعريفي للمستخدم",
    icon: Business,
    iframeUrl: 'http://esriven.maps.arcgis.com/apps/opsdashboard/index.html#/1a9da053d1b74288935d7d3e0a63175b',
    component: DashboardPage,
    layout: "/admin"
  }
];

export default dashboardRoutes;
